import { api } from "./client";
import type { BillCardPayment } from "./bills";

/**
 * Справка „Картови плащания" — GET /reports/analytics/card-payments.
 * Сверката на края на деня: заведенски отчет „карта" + „Бакшиш с карта"
 * (`card_paid_amount` на отчета) = consumed_total — картовото теглене носи и
 * бакшиша с карта; терминалът = consumed + unresolved; банката = consumed
 * (+ voided нетно 0).
 * Контрактът е в BE docs/card-payments.md (кросрепо ред 15).
 */

export interface CardPaymentReportRow extends BillCardPayment {
  bill_name: string | null;
}

export interface CardTerminalSummary {
  printer_guid: string | null;
  // "pc" (терминал на касата) | "fiscal" (терминал на принтера)
  mount: string;
  consumed_count: number;
  // Decimal от BE → JSON НИЗ (виж cross-repo-contract ред 1) — Number() преди аритметика.
  consumed_total: string;
  voided_count: number;
  voided_total: string;
  unresolved_count: number;
  unresolved_total: string;
  missing_receipt_count: number;
  refunded_count: number;
}

export interface CardPaymentsReportResponse {
  terminals: CardTerminalSummary[];
  rows: CardPaymentReportRow[];
  total: number;
}

export interface CardPaymentsReportFilters {
  start_date?: string;
  end_date?: string;
  /** Филтърът „смяна" (`lib/reportShift.ts`); без него — всички смени. */
  shift?: number;
}

export const getCardPaymentsReport = async (
  filters?: CardPaymentsReportFilters,
): Promise<CardPaymentsReportResponse> => {
  const params = new URLSearchParams();
  if (filters?.start_date) params.append("start_date", filters.start_date);
  if (filters?.end_date) params.append("end_date", filters.end_date);
  if (filters?.shift) params.append("shift", String(filters.shift));
  const queryString = params.toString();
  const url = `/reports/analytics/card-payments${queryString ? `?${queryString}` : ""}`;
  const response = await api.get<CardPaymentsReportResponse>(url);
  return response.data;
};
